import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Plus, Tick } from '../../helpers/icon-dictionary';
import css from './index.scss';
import SvgIcon from '../svg-icon/svg-icon';
import Button from '../../components/button/index';
import messages from './messages';

const TeacherConfirmation = ({ icon, title, handleOnAddTeacher, handleOnCloseModal, intl }) => (
    <div className={css.teacherConfirmationContainer}>
        <div className={css.icon}>
            <SvgIcon icon={icon} />
        </div>
        <div className={css.title}>{title}</div>
        <Button
            buttonContainer={css.buttonContainer}
            containerClassName={css.buttonWrapper}
            handleOnClick={handleOnAddTeacher}
            icon={Plus}
            iconClassName={css.buttonIcon}
            label={intl.formatMessage(messages.addAnotherTeacher)} />
        <Button
            buttonContainer={css.buttonContainer}
            containerClassName={css.buttonWrapper}
            handleOnClick={handleOnCloseModal}
            icon={Tick}
            iconClassName={css.buttonIcon}
            label={intl.formatMessage(messages.done)} />
    </div>
);

TeacherConfirmation.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string,
    handleOnAddTeacher: PropTypes.func,
    handleOnCloseModal: PropTypes.func,
    intl: intlShape.isRequired
};

export default injectIntl(TeacherConfirmation);



// WEBPACK FOOTER //
// ./app/components/teacher-confirmation/index.js